<template>
  <span :class="[spanClasses, {hide: isLoading}]">
    {{displayNumber}}
  </span>
</template>

<script>
  export default {
    props: {
      duration: Number,
      isLoading: Boolean,
      spanClasses: String,
      updatedValue: Number,
    },

    data() {
      return {
        calculatedValue: 0,
        displayNumber: 0,
        intervalCounter: null,
        isDecrease: false,
        step: 1,
        stepTime: 1,
      };
    },

    methods: {
      countTo() {
        if (this.updatedValue !== this.calculatedValue) {
          const start = parseInt(this.calculatedValue),
            end = parseInt(this.updatedValue),
            countUp = start < end,
            range = Math.abs(end - start),
            fps = 100,
            duration = this.duration ? this.duration : 1000,
            iterations = fps * duration

          this.step = Math.ceil(duration / iterations)
          this.stepTime = duration / fps

          this.stepCount(0, start, end, range, duration, countUp)
        }
      },

      easing(time, start, range, duration) {
        // ideas from: https://stackoverflow.com/questions/8316882/what-is-an-easing-function
        // still needs easing in with the time
        if ((time /= duration / 2) < 1) {
          return range / 2 * time * time
        } else {
          return -range / 2 * ((--time) * (time - 2) - 1)
        }
      },

      stepCount(time, start, end, range, duration, countUp) {
        this.intervalCounter = setInterval(function() {
          let easeCount = this.easing(time, start, range, duration)
          time += this.step
          start = countUp ? easeCount + start : start - easeCount
          const stopIncrease = start >= end,
            stopDecrease = start <= end,
            stopCount = countUp ? stopIncrease : stopDecrease
          if (stopCount) {
            clearInterval(this.intervalCounter)
            this.calculatedValue = this.updatedValue
          }
          return this.displayNumber = stopCount ? this.updatedValue : Math.ceil(start)
        }.bind(this), this.stepTime)
      },
    },

    created() {
      this.countTo()
    },

    watch: {
      updatedValue: function() {
        if (this.intervalCounter) {
          clearInterval(this.intervalCounter)
          this.displayNumber = this.calculatedValue
          this.countTo()
        } else {
          this.countTo()
        }
      }
    }

  }
</script>